export const getSitewideDataFilter = (siteIdFilter: string) => (siteIdFilter ? `[${siteIdFilter}]` : '[]');
